/**
 * Analytics for main menu.
 */

import dataLayerPush from "./dataLayerPush";
import cleanHref from "../help/cleanHref";

const eventCategory = "Navigation";

/**
 * Track click main menu.
 *
 * @param {string} menuTitle title of link.
 * @param {string} clickURL url of link.
 */
export function trackMainMenuClick(menuTitle, clickURL) {
  const cleanURL = cleanHref(clickURL);
  const eventLabel = `Menu Title: ${menuTitle} | Navigated To: ${cleanURL}`;
  const eventVars = { menuTitle, cleanURL };
  dataLayerPush(
    eventLabel,
    eventVars,
    "mainMenuNavigation",
    "Selected Main Menu Item",
    eventCategory
  );
}

/**
 * Track click submenu.
 *
 * @param {string} subMenuTitle title of link.
 * @param {string} clickURL url of link.
 */
export function trackSubmenuClick(subMenuTitle, clickURL) {
  const cleanURL = cleanHref(clickURL);
  const eventLabel = `Sub Menu Title: ${subMenuTitle} | Navigated To: ${cleanHref(clickURL)}`;
  const eventVars = { subMenuTitle, cleanURL };
  dataLayerPush(
    eventLabel,
    eventVars,
    "subMenuNavigation",
    "Selected Sub Menu Item",
    eventCategory
  );
}

/**
 * Track click solution filter.
 *
 * @param {string} filterTerm title of term.
 */
export function trackSolutionFilterClick(filterTerm) {
  const eventLabel = `Solution Term: ${filterTerm}`;
  const eventVars = { filterTerm };
  dataLayerPush(
    eventLabel,
    eventVars,
    "subMenuNavigation",
    "Filtered Solutions by Term",
    eventCategory
  );
}
